// extracted by mini-css-extract-plugin
export default {"c5__content":"c5_c5__content__cnJ2y","c5__content_text":"c5_c5__content_text__TlVz3"};